import './list-visor-drawer.scss';

import ListVisorDrawer from './ListVisorDrawer';

export default ListVisorDrawer;
